import { createFileRoute, Navigate, useRouter } from "@tanstack/react-router";

import { validateIndex } from "@/app/lib/routeValidation";
import { HotelGallery } from "@/features/hotels/components/hotel/HotelGallery";
import { useHotelOffersContext } from "@/features/hotels/contexts/HotelOffersContext";

export const Route = createFileRoute(
  "/_authenticated/_hotels/_hotel-offer/hotels/$id/rooms_/$roomToken/images_/fullscreen",
)({
  validateSearch: validateIndex,
  component: RouteComponent,
  staticData: {
    hotelStep: {
      presentationMode: "modal",
      stepNumber: 2,
    },
    drawer: false,
  },
});

function RouteComponent() {
  const { roomToken } = Route.useParams();
  const { index } = Route.useSearch();
  const router = useRouter();

  const { data: offers } = useHotelOffersContext();

  const room = offers
    .flatMap((offer) => offer.rooms.flatMap((room) => room.options))
    .find((option) => option.roomToken === roomToken);

  if (!room) {
    return <Navigate to=".." from={Route.fullPath} />;
  }

  return (
    <HotelGallery
      images={room.images || []}
      initialIndex={index}
      onBackClick={() => router.history.back()}
    />
  );
}
